import { render, staticRenderFns } from "./LeftImage.vue?vue&type=template&id=55e1ae57&scoped=true&"
import script from "./js/leftImage.js?vue&type=script&lang=js&"
export * from "./js/leftImage.js?vue&type=script&lang=js&"
import style0 from "./LeftImage.vue?vue&type=style&index=0&id=55e1ae57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e1ae57",
  null
  
)

export default component.exports